
import MigrationAlert from "@/components/dashboard/MigrationAlert";

interface MigrationSectionProps {
  showMigration: boolean;
  isMigrating: boolean;
  onMigrateData: () => void;
  migrationError?: string | null;
}

const MigrationSection = ({
  showMigration,
  isMigrating,
  onMigrateData,
  migrationError
}: MigrationSectionProps) => {
  // Always return null to hide the migration section
  return null;
};

export default MigrationSection;
